import { timeParse } from 'd3'

const assetStabilityChartData = [
    {
        "dateString": "2010-12-31",
        "tang_over_assets_deviation": "",
        "tang_over_assets_h_deviation": "1.178679887",
        "chart_name": "Asset Stability (Physical Assets as a % of Fixed Assets)",
        "chart_number": "5"
    },
    {
        "dateString": "2011-06-30",
        "tang_over_assets_deviation": "",
        "tang_over_assets_h_deviation": "1.302859547",
        "chart_name": "Asset Stability (Physical Assets as a % of Fixed Assets)",
        "chart_number": "5"
    },
    {
        "dateString": "2011-12-31",
        "tang_over_assets_deviation": "",
        "tang_over_assets_h_deviation": "1.460890129",
        "chart_name": "Asset Stability (Physical Assets as a % of Fixed Assets)",
        "chart_number": "5"
    },
    {
        "dateString": "2012-06-30",
        "tang_over_assets_deviation": "",
        "tang_over_assets_h_deviation": "1.326232965",
        "chart_name": "Asset Stability (Physical Assets as a % of Fixed Assets)",
        "chart_number": "5"
    },
    {
        "dateString": "2012-12-31",
        "tang_over_assets_deviation": "",
        "tang_over_assets_h_deviation": "1.335910817",
        "chart_name": "Asset Stability (Physical Assets as a % of Fixed Assets)",
        "chart_number": "5"
    },
    {
        "dateString": "2013-06-30",
        "tang_over_assets_deviation": "0.459625025",
        "tang_over_assets_h_deviation": "1.422335215",
        "chart_name": "Asset Stability (Physical Assets as a % of Fixed Assets)",
        "chart_number": "5"
    },
    {
        "dateString": "2013-12-31",
        "tang_over_assets_deviation": "0.502426997",
        "tang_over_assets_h_deviation": "1.413105855",
        "chart_name": "Asset Stability (Physical Assets as a % of Fixed Assets)",
        "chart_number": "5"
    },
    {
        "dateString": "2014-06-30",
        "tang_over_assets_deviation": "0.457783503",
        "tang_over_assets_h_deviation": "1.274408725",
        "chart_name": "Asset Stability (Physical Assets as a % of Fixed Assets)",
        "chart_number": "5"
    },
    {
        "dateString": "2014-12-31",
        "tang_over_assets_deviation": "-0.443917945",
        "tang_over_assets_h_deviation": "1.106219183",
        "chart_name": "Asset Stability (Physical Assets as a % of Fixed Assets)",
        "chart_number": "5"
    },
    {
        "dateString": "2015-06-30",
        "tang_over_assets_deviation": "-0.467803873",
        "tang_over_assets_h_deviation": "1.088332232",
        "chart_name": "Asset Stability (Physical Assets as a % of Fixed Assets)",
        "chart_number": "5"
    },
    {
        "dateString": "2015-12-31",
        "tang_over_assets_deviation": "-0.459003278",
        "tang_over_assets_h_deviation": "1.151290027",
        "chart_name": "Asset Stability (Physical Assets as a % of Fixed Assets)",
        "chart_number": "5"
    },
    {
        "dateString": "2016-06-30",
        "tang_over_assets_deviation": "-0.395523543",
        "tang_over_assets_h_deviation": "1.18538664",
        "chart_name": "Asset Stability (Physical Assets as a % of Fixed Assets)",
        "chart_number": "5"
    },
    {
        "dateString": "2016-12-31",
        "tang_over_assets_deviation": "-0.211157546",
        "tang_over_assets_h_deviation": "1.231907909",
        "chart_name": "Asset Stability (Physical Assets as a % of Fixed Assets)",
        "chart_number": "5"
    },
    {
        "dateString": "2017-06-30",
        "tang_over_assets_deviation": "-0.275065401",
        "tang_over_assets_h_deviation": "1.25222944",
        "chart_name": "Asset Stability (Physical Assets as a % of Fixed Assets)",
        "chart_number": "5"
    },
    {
        "dateString": "2017-12-31",
        "tang_over_assets_deviation": "-0.444007742",
        "tang_over_assets_h_deviation": "1.214887071",
        "chart_name": "Asset Stability (Physical Assets as a % of Fixed Assets)",
        "chart_number": "5"
    },
    {
        "dateString": "2018-06-30",
        "tang_over_assets_deviation": "2.53478089",
        "tang_over_assets_h_deviation": "1.434569677",
        "chart_name": "Asset Stability (Physical Assets as a % of Fixed Assets)",
        "chart_number": "5"
    },
    {
        "dateString": "2018-12-31",
        "tang_over_assets_deviation": "2.024107809",
        "tang_over_assets_h_deviation": "1.479890643",
        "chart_name": "Asset Stability (Physical Assets as a % of Fixed Assets)",
        "chart_number": "5"
    },
    {
        "dateString": "2019-06-30",
        "tang_over_assets_deviation": "1.748059934",
        "tang_over_assets_h_deviation": "1.144121997",
        "chart_name": "Asset Stability (Physical Assets as a % of Fixed Assets)",
        "chart_number": "5"
    },
    {
        "dateString": "2019-12-31",
        "tang_over_assets_deviation": "1.830910311",
        "tang_over_assets_h_deviation": "1.160005706",
        "chart_name": "Asset Stability (Physical Assets as a % of Fixed Assets)",
        "chart_number": "5"
    },
    {
        "dateString": "2020-06-30",
        "tang_over_assets_deviation": "1.857605401",
        "tang_over_assets_h_deviation": "1.217204825",
        "chart_name": "Asset Stability (Physical Assets as a % of Fixed Assets)",
        "chart_number": "5"
    }
]

const parseDate = timeParse('%Y-%m-%d')

export default assetStabilityChartData.map(d => {
  d['date'] = parseDate(d['dateString'])
  return d
})
